import apiFailureImg from "../../assets/images/apiFailureImgHighRes.png";
import { ReactComponent as SearchItemNotFound } from "../../assets/images/searchItemNotFound.svg";

const AlternateView = ({
  apiStates = {},
  alternateDivs = {},
  searchTerm = "",
  data = [],
  table = { getRowModel: () => ({ rows: [] }) },
  columnFilters = [], // Add this prop
  isMySpace = false,
  isCustomModule = false,
  isMySpaceCreateColumnHtml = () => {},
}) => {
  const isError = Boolean(apiStates?.header?.isError || apiStates?.body?.isError);
  const isLoading = Boolean(apiStates?.header?.isLoading || apiStates?.body?.isLoading);
  const rows = typeof table.getRowModel === "function" ? table.getRowModel().rows : [];
  const isLoaded = !isLoading;

  const isEmptyData = data?.length === 0;
  const isSearchEmpty =
    rows?.length === 0 && data?.length !== 0 && (searchTerm?.trim() !== "" || columnFilters.lenght > 0);
  const hasActiveFilters = searchTerm?.trim() !== "" || columnFilters?.length > 0;
  const isFilterEmpty = rows?.length === 0 && data?.length !== 0 && hasActiveFilters;
  console.log("alternate view ", rows?.length === 0, data?.length !== 0, searchTerm?.trim() !== "");
  let divToBeRendered = null;

  if (isMySpace || isCustomModule) {
    divToBeRendered = "myspace";
  } else if (isError) {
    divToBeRendered = "apiFailure";
  } else if (isLoading) {
    divToBeRendered = "loading";
  } else if (isLoaded && isEmptyData) {
    divToBeRendered = "emptyData";
  } else if (isLoaded && isSearchEmpty) {
    divToBeRendered = "search";
  } else if (isLoaded && isFilterEmpty) {
    divToBeRendered = "search";
  }

  console.log("abhishek", divToBeRendered);

  switch (divToBeRendered) {
    case "apiFailure":
      return (
        <div className="w-full h-full flex items-center justify-center">
          <div className="flex flex-col items-center">
            <img src={apiFailureImg} className="w-[490px] h-[245px]" alt="API failure" />
            <span className="text-[#1C3E60] text-center font-[400] text-[32px] leading-[51px] font-[Poor Richard]">
              “Oops! Something unexpected happened. Please try again.”
            </span>
          </div>
        </div>
      );

    case "loading":
      return <></>;

    case "myspace":
      return isMySpaceCreateColumnHtml();

    case "emptyData":
      return alternateDivs.emptyData || null;

    case "search":
      return (
        <div className="w-full h-full flex items-center justify-center">
          <div className="flex flex-col items-center">
            <SearchItemNotFound />
            <span className="text-[#666666] text-center font-Inter text-14 font-400 leading-normal">
              No Record Found
            </span>
          </div>
        </div>
      );

    default:
      return <></>;
  }
};

export default AlternateView;
